import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://hzbdlpteazzwgnavpeej.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || 'sb_publishable_Cj5pLTuBmvMTXu6Frvy1CQ_Siw5WNqB';

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: { persistSession: false, autoRefreshToken: false },
    })
  : null;
